import React, { useState, useEffect } from 'react';
import { apiService } from '../services/api';
import type { Profile } from '../types';
import { Link } from 'react-router-dom';

const ProfilesPage: React.FC = () => {
  const [profiles, setProfiles] = useState<Profile[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchProfiles = async () => {
      try {
        setLoading(true);
        const fetchedProfiles = await apiService.getProfiles();
        setProfiles(fetchedProfiles);
        setError(null);
      } catch (err) {
        if (err instanceof Error) {
            setError(err.message);
        } else {
            setError('An unknown error occurred');
        }
      } finally {
        setLoading(false);
      }
    };

    fetchProfiles();
  }, []);

  if (loading) {
    return <div className="text-center p-8">Loading profiles...</div>;
  }

  if (error) {
    return <div className="text-center p-8 text-red-500">Error: {error}</div>;
  }

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-3xl font-bold mb-6">Perfis de Comunicação</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {profiles.map((profile) => (
          <div key={profile.id} className="border rounded-lg p-4 shadow-lg hover:shadow-xl transition-shadow">
            <h2 className="text-2xl font-semibold mb-2">{profile.name}</h2>
            <p className="text-gray-700 mb-4">{profile.descricao_resumo}</p>
            <Link to={`/profiles/${profile.id}`} className="text-blue-500 hover:underline">
              Ver Detalhes
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProfilesPage; 